import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'si-text-area',
  imports: [FormsModule, CommonModule, MatInputModule],
  templateUrl: './si-text-area.component.html',
  styleUrl: './si-text-area.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SiTextAreaComponent),
      multi: true
    }
  ]
})
export class SiTextAreaComponent implements ControlValueAccessor {

  private internalValue = '';
  private formControlDisabled = false;

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  @Input()
  set value(value: string | undefined) {
    this.internalValue = value ?? '';
  }
  get value(): string {
    return this.internalValue;
  }

  @Input() isDisabled: boolean = false;

  @Input() isReadMode: boolean = true;

  get effectiveDisabled(): boolean {
    return this.isDisabled || this.formControlDisabled;
  }

  writeValue(value: string | null): void {
    this.internalValue = value ?? '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDisabled = isDisabled;
  }

  onValueChange(value: string): void {
    this.internalValue = value ?? '';
    this.onChange(this.internalValue);
  }

  onBlur(): void {
    this.onTouched();
  }

}
